export const imageLink = (imageId: string): string => {
  return `${process.env.REACT_APP_ENDPOINT_BASE_URL}/image/${imageId}`;
};
